<ngx-ui-loader
  [bgsColor]="'blue'"
  [bgsOpacity]="1"
  [bgsPosition]="'center-center'"
  [bgsSize]="20"
 ></ngx-ui-loader>


<div id="appHeader" class="appHeader" >

    
    <div style="max-width: 1700px;display: flex;width: 100vw;">
      <div class="dottedBorder" style="width: 25%;height: 100%;display: flex;">
        <div class="dottedBorder" style="width: 5%;height: 100%;">

        </div>
        <div  (click)="homePage()" class="dottedBorder centerWithFlex" style="width: 65%;height: 100%; cursor: pointer;">
             <img style="height: 80%; width: 80%;" src="../assets/vaadude_old.png">
        </div>

       
  </div>
  <div class="dottedBorder"  style="width: 43%;height: 100%;" [ngClass]="{nonLoggedIn:!getIsLoggedIn()}">

  </div>
  <div id="aboutUs" class="dropdown" style="width: 10%;height: 100%;justify-content: center;align-items: center;
  display: flex;cursor: pointer;font-size: small; font-weight: 600;" (click)="openContactUsPopup()">
                 CONTACT US

                
  </div>

   <div id="aboutUs" class="dropdown" style="width: 10%;height: 100%;justify-content: center;align-items: center;
   display: flex;cursor: pointer;font-size: small; font-weight: 600;" (click)="openAboutUsPopup()">
                  ABOUT US

                  <!-- <div class="aboutus">
                    <div class="content">
                      Vaadude.com is a social networking site where IT professionals can read and exchange news, technical conversation, and job posting.

                    </div>
                  </div> -->
   </div>

  <div *ngIf="getIsLoggedIn()" class="dottedBorder" style="width: 20%;height: 100%;display: flex; align-items: center; border-left: 1px solid #d2e6f7;">
    <div class="dottedBorder centerWithFlex" (click)="homePage()"  style="width: 25%;height: 100%;">
      <mat-icon class="iconHoverStyle">home</mat-icon>
    </div>
    <div class="dottedBorder centerWithFlex"  style="width: 25%;height: 100%;">
      <mat-icon class="iconHoverStyle">bookmark_border</mat-icon>
    </div>
    <div class="dottedBorder centerWithFlex" style="width: 25%;height: 100%; border-right: 1px solid #d2e6f7;">
      <mat-icon class="iconHoverStyle">notifications</mat-icon>
    </div>
    <div class="dottedBorder centerWithFlex" style="width: 25%;height: 100%;cursor: pointer;">
           <div class="dottedBorder roundedDiv centerWithFlex" [popover]="myPopover" [popoverOnHover]="false">
                 {{getUserNameForProfile()}}
           </div>
    </div>
  </div>

  <div *ngIf="!getIsLoggedIn()" class="dottedBorder" style="width: 5%;height: 100%;display: flex; align-items: center; border-left: 1px solid #d2e6f7;">
    <div class="dottedBorder centerWithFlex" (click)="homePage()"  style="width: 99%;height: 100%;">
      <mat-icon class="iconHoverStyle">home</mat-icon>
    </div>
   
  </div>

  <div *ngIf="!getIsLoggedIn()" class="dottedBorder" style="width: 5%;height: 100%;display: flex; align-items: center;
   justify-content: flex-end;border-left: 1px solid #d2e6f7;">
    <!-- <div class="dottedBorder centerWithFlex"  style="width: 75%;height: 100%; border-right: 1px solid #d2e6f7;"></div> -->
    <div class="dottedBorder centerWithFlex"  style="width: 100%;height: 100%;">
      <mat-icon class="iconHoverStyle" id="loginButtonClick" (click)="goToLogin()">login</mat-icon>
    </div>
  </div>

  <div class="dottedBorder" style="width: 2%;height: 100%;">

  </div>
    </div>  
  
      
</div>

<div *ngIf="showtopmenu" id="topmenu" class="topmenu">
       <div class="formRow-5 bothCenter">

       </div>
       <div [ngClass]="{selectedMenu:checkSelectedMenu(FEEDS)}" (click)="goToFeeds()" class="formRow-30 bothCenter fontAndFamily menu">
               News
       </div>
       <div [ngClass]="{selectedMenu:checkSelectedMenu(JOB_OPENINGS)}" (click)="goToJobOpening()" class="formRow-30 bothCenter fontAndFamily menu">
        Jobs
       </div>
       <div [ngClass]="{selectedMenu:checkSelectedMenu(QUESTIONS)}" (click)="goToTechQuestions()" class="formRow-30 bothCenter fontAndFamily menu">
        Tech Talk
       </div>
       <div class="formRow-5 bothCenter">

       </div>
</div>

<div style="width: 100vw;display: flex;justify-content: center;background-color: #f3f2ef;">
<div id="appBody" [ngClass]="{appBody:showtopmenu,appBodyFull:!showtopmenu}">
      <router-outlet style="height: 100%;width: 100%;">

      </router-outlet>
</div>
</div>
<!-- <div id="appFooter" class="appFooter centerWithFlex">
           <div class="centerWithFlex" style="width: 20%;height: 100%;font-size: 12px;">
                    copyrights vaadude 2022
           </div>
</div> -->

<popover-content #myPopover 
                title="" 
                placement="left"
                [animation]="true" 
                [closeOnClickOutside]="true" >

                <div style="width: 10vw;" id="pop_content">
                      <div class="fontAndFamily" (click)="goToFeeds()" style="cursor: pointer;width: 100%;border-bottom: solid 1px grey;
                      display: flex;justify-content: center;height: 30px;align-items: center;">
                               Menu
                       </div>
                       <div class="fontAndFamily" (click)="goToDashboard()" style="cursor: pointer;width: 100%;border-bottom: solid 1px grey;
                      display: flex;justify-content: center;height: 30px;align-items: center;">
                               Dashboard
                       </div>
                       <div *ngIf="getIsAdmin()" class="fontAndFamily" (click)="goToUserList()" style="cursor: pointer;width: 100%;border-bottom: solid 1px grey;
                       display: flex;justify-content: center;height: 30px;align-items: center;">
                                Users
                        </div>
                       <div class="fontAndFamily" (click)="logout()" style="cursor: pointer;width: 100%;display: flex;justify-content: center;height: 30px;align-items: center;">
                               Logout
                       </div>
                </div>
   
</popover-content>

